<template>
    <div name="soldoc-certification" class="soldoc-certification">
        <div class="soldoc-certification-inner">
            <h3>솔닥은 계속해서<br>발전해 나가고 있습니다</h3>
            <div class="history-area">
                <ul>
                    <li>
                        <div>                            
                            <strong>솔닥, 중소벤처기업부<br>장관상 수상</strong>
                            <span>2023.12</span>
                        </div>
                        <div>                            
                            <strong>솔닥, 보건복지부<br>장관상 수상</strong>
                            <span>2023.07</span>
                        </div>
                    </li>
                    <li>
                        <div>                            
                            <strong>서울 부산시 주관<br>우수 스타트업 선정</strong>
                            <span>2022.11</span>
                        </div>
                        <div>                            
                            <strong>원격진료 처방 및 의약품<br>배송 관련 기술 특허 등록</strong>
                            <span>2022.10</span>
                        </div>
                    </li>
                    <li>
                        <div>                            
                            <strong>비대면진료를 이용한 환자<br>서비스 관련 기술 특허 등록</strong>
                            <span>2022.10</span>
                        </div>
                        <div>                            
                            <strong>업계 최초 ESG 경영<br>적합 판정</strong>
                            <span>2022.09</span>
                        </div>
                        <div>                            
                            <strong>연세대학교와 헬스케어<br>AI분석 공동 특허 등록</strong>
                            <span>2021.12</span>
                        </div>
                    </li>
                    <li>
                        <div>                            
                            <strong>비대면진료를 위한<br>인공지능 기반 기술 특허 등록</strong>
                            <span>2021.12</span>
                        </div>
                        <div>                            
                            <strong>보건복지부 비대면진료<br>특화 사업체 선정</strong>
                            <span>2021.06</span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "soldoc-certification",
    data: function() {
        return {};
    },
    computed: {},
    mounted: function() {
        $(window).scroll(function() {
            var height = $(document).scrollTop();
            var innerTop = $(".soldoc-certification-inner").offset().top;
            var aniTitle = $(".soldoc-certification-inner h3");
            var aniItem = $(".soldoc-certification-inner .history-area");

            if (height <= 0) {
                $(aniTitle).removeClass('item-show').addClass('item-hide');
                $(aniItem).removeClass('item-show').addClass('item-hide');
            } else if (height > innerTop - 500 && height < innerTop + 1000) {
                $(aniTitle).removeClass('item-hide').addClass('item-show');
                $(aniItem).removeClass('item-hide').addClass('item-show');
            } else if (height > innerTop + 1000) {
                $(aniTitle).removeClass('item-show').addClass('item-hide');
                $(aniItem).removeClass('item-show').addClass('item-hide');
            }
        });
    },
    methods: {},
};
</script>

<style scoped>
.soldoc-certification {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    height: 972px;
    background: #1A1F27;
}
.soldoc-certification::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 385px;
    background: url(../../assets/partners_pc/bg_soldoc_certification.png) center 0 no-repeat;
    background-size: 2000px 385px;
}
.soldoc-certification .soldoc-certification-inner {    
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 1240px;
    padding: 154px 20px;
}
.soldoc-certification-inner h3 {
    min-height: 123px;
    margin-bottom: 0;
    font-size: 46px;
    font-weight: 600;
    line-height: 60px;
    color: #FFF;
    text-align: center;
    visibility: hidden;
    opacity: 0;
}
.soldoc-certification-inner .history-area {
    margin-top: 93px;
    visibility: hidden;
    opacity: 0;
}
.soldoc-certification-inner .item-hide {
    visibility: hidden;
    opacity: 0;
}
.soldoc-certification-inner .item-show {
    visibility: visible;
    opacity: 1;
    animation: fadeInUp1 2s;
}
.soldoc-certification .history-area ul {
    display: flex;
    align-items: flex-start;
    list-style: 0;
    margin: 0;
    padding: 0;
}
.soldoc-certification .history-area ul li {
    position: relative;
    width: 300px;
    padding-left: 24px;
}
.soldoc-certification .history-area ul li::before {
    content: '';
    position: absolute;
    top: 4px;
    left: 0;
    width: 1px;
    height: 279px;
    background: rgba(255, 255, 255, 0.30);
}
.soldoc-certification .history-area ul li:nth-child(3)::before {
    height: 430px;
}
.soldoc-certification .history-area ul li div + div {
    margin-top: 45px;
}
.soldoc-certification .history-area ul li strong {
    display: block;
    min-height: 71px;
    margin-bottom: 12px;
    font-size: 22px;
    font-weight: 600;
    line-height: 34px;
    color: #FFF;
}
.soldoc-certification .history-area ul li span {
    font-size: 14px;
    font-weight: 400;
    line-height: 36px;
    color: #008DEF;
}
@keyframes fadeInUp1 {
    0% {
        opacity: 0;
        transform: translate3d(0, 30%, 0);
    }
    to {
        opacity: 1;
        transform: translateZ(0);
    }
}
@keyframes fadeInUp2 {
    0% {
        opacity: 0;
        transform: translate3d(0, 100%, 0);
    }
    to {
        opacity: 1;
        transform: translateZ(0);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/pc_partners/SoldocCertification.vue